// extracted by mini-css-extract-plugin
export var categoryIcon = "_di-5";
export var connectorContainer = "_di-1";
export var connectorLine = "_di-0";
export var minHeight0 = "_di-6";
export var relativeUnitValueSelector = "_di-2";
export var trifoldSelectorBody = "_di-4";
export var trifoldSelectorList = "_di-3";